<div class="st-drawer-wrapper opportunities-details-drawer flex flex-column">
  <a href=""></a>
  <!--  Header  -->
  @if (viewMode === 'budget' ? budget : opportunity) {
  <div class="st-drawer-header show-border flex-center-between">
    <div class="flex-center gap-150">
      @if (viewMode === 'budget') {
      @if (hasMultipleBudgets) {
      <button (click)="changeBudget(false, true)" nz-button nzType="text" nzShape="circle" nzSize="small"
        class="flex-center">
        <app-st-icon [bold]="true" style="font-size: 18px" class="cursor-pointer" [name]="'keyboard_arrow_up'">
        </app-st-icon>
      </button>
      <button (click)="changeBudget(true, false)" nz-button nzType="text" nzShape="circle" nzSize="small"
        class="flex-center">
        <app-st-icon [bold]="true" style="font-size: 18px" class="cursor-pointer" [name]="'keyboard_arrow_down'">
        </app-st-icon>
      </button>
      }
      <span class="text-label-14" style="color: #666666;">Oportunidades /</span>
      <span class="text-label-14 text-semibold text-nowrap cursor-pointer" (click)="closeBudgetView()"
        style="color: #666666; text-decoration: none;">
        {{ opportunityName }}
      </span>
      <span class="text-label-14" style="color: #666666;">/</span>
      <div class="flex-center gap-050 cursor-pointer" nz-dropdown nzTrigger="click"
        [nzDropdownMenu]="hasMultipleBudgets ? budgetDropdownTmpl : null">
        <span class="text-label-14 text-semibold text-nowrap" style="color: #171717; text-decoration: none;">{{
          budgetNavigationReference }}</span>
        <app-st-icon *ngIf="hasMultipleBudgets" [bold]="true" [name]="'keyboard_arrow_down'">
        </app-st-icon>
      </div>

      <nz-dropdown-menu #budgetDropdownTmpl="nzDropdownMenu">
        <ul nz-menu class="opportunity-dropdown">
          @for (budgetItem of budgetList; track budgetItem.id) {
          <li (click)="changeBudget(false, false, budgetItem.id)" [class.selected]="budgetItem.id === budget?.id"
            nz-menu-item style="min-width: fit-content">
            {{ getBudgetNavigationReference(budgetItem) }}
          </li>
          }
        </ul>
      </nz-dropdown-menu>
      } @else {<!-- Navegación entre oportunidades/leads -->

      @if (hasMultipleOpportunities) {
      <button (click)="changeOpportunity(false, true, currentOpportunityId)" nz-button nzType="text" nzShape="circle"
        nzSize="small" class="flex-center">
        <app-st-icon [bold]="true" style="font-size: 18px" class="cursor-pointer" [name]="'keyboard_arrow_up'">
        </app-st-icon>
      </button>
      <button (click)="changeOpportunity(true, false, currentOpportunityId)" nz-button nzType="text" nzShape="circle"
        nzSize="small" class="flex-center">
        <app-st-icon [bold]="true" style="font-size: 18px" class="cursor-pointer" [name]="'keyboard_arrow_down'">
        </app-st-icon>
      </button>
      }
      @if (isLead) {
      <span class="text-label-14" style="color: #666666;">Leads /</span>
      } @else {
      <span class="text-label-14" style="color: #666666;">Oportunidades /</span>
      }
      <div class="flex-center gap-050 cursor-pointer" nz-dropdown nzTrigger="click"
        [nzDropdownMenu]="hasMultipleOpportunities ? opportunityDropdownTmpl : null">
        <span class="text-label-14 text-semibold text-nowrap" style="color: #171717; text-decoration: none;">{{
          opportunityName }}</span>
        <app-st-icon *ngIf="hasMultipleOpportunities" [bold]="true" [name]="'keyboard_arrow_down'">
        </app-st-icon>
      </div>

      <nz-dropdown-menu #opportunityDropdownTmpl="nzDropdownMenu">
        <ul nz-menu class="opportunity-dropdown">
          @for (opp of nzData.opportunityList; track opp.id || opp.originalId) {
          <li (click)="changeOpportunity(false, false, opp.id || opp.originalId)"
            [class.selected]="(opp.id || opp.originalId) === currentOpportunityId" nz-menu-item
            style="min-width: fit-content">
            {{ opp.oportunidad || opp.originalOpportunityName || opp.name || '-' }}
          </li>
          }
        </ul>
      </nz-dropdown-menu>
      }
    </div>
    <app-st-icon class="text-header-16" style="cursor: pointer" (click)="close()" name="close"></app-st-icon>

    <!-- Botón para expandir/colapsar panel de actividades en móvil -->
    <button *ngIf="screenService.isMobile$ | async" nz-button nzType="default" nzShape="circle" nzSize="small"
      class="activities-toggle-btn" [title]="showActivitiesPanel ? 'Colapsar actividades' : 'Expandir actividades'"
      (click)="toggleActivitiesPanel()">
      <app-st-icon [name]="showActivitiesPanel ? 'expand_less' : 'expand_more'" [bold]="true">
      </app-st-icon>
    </button>
  </div>

  @if (!loading) {
  <!-- Título, botón de editar y acciones -->
  <div class="opportunity-header-section">
    <div class="flex-center gap-200">
      @if (viewMode === 'budget') {
      <h2 class="text-header-24 text-semibold">{{ saleOrderName }}</h2>
      <ng-container *ngIf="nzData.editPermissions">
        <button *ngIf="!isBudgetEditModeEnabled && !budget?.id" (click)="startEditModeBudget()" nz-button nzType="default"
          nzShape="round">
          <app-st-icon class="text-header-16 cursor-pointer prefix" style="margin-right: 8px" name="edit"
            [bold]="true"></app-st-icon>
          Editar Presupuesto
        </button>
        <ng-container *ngIf="isBudgetEditModeEnabled">
          <button nz-button nzType="default" nzShape="round" style="margin-right: 8px"
            (click)="cancelEditModeBudget()">
            <app-st-icon class="text-header-16 cursor-pointer prefix" style="margin-right: 8px" name="close"
              [bold]="true"></app-st-icon>
            Cancelar
          </button>
          <button nz-button nzType="primary" nzShape="round" [nzLoading]="savingBudget" (click)="saveEditModeBudget()">
            <app-st-icon class="text-header-16 cursor-pointer prefix" style="margin-right: 8px; color: #ffffff;"
              name="done" [bold]="true"></app-st-icon>
            Guardar
          </button>
        </ng-container>
      </ng-container>
      } @else {
      <h2 class="text-header-24 text-semibold">{{ opportunityName }}</h2>
      }
    </div>

    <div class="flex-center gap-100">
      <!-- Botones de presupuesto -->
      @if (viewMode === 'budget') {
      <button nz-button nzType="default" nzShape="round" [disabled]="isBudgetEditModeEnabled"
        (click)="closeBudgetView()">
        Volver
      </button>
      <button *ngIf="hasBudgetQuotationLines" nz-button nzType="default" nzShape="round" [disabled]="isBudgetEditModeEnabled || !budget?.id"
        [nzLoading]="previewingBudget" (click)="openBudgetPreview()">
        Vista previa
      </button>
      <button *ngIf="hasBudgetQuotationLines && budget?.isActive" nz-button nzType="primary" nzShape="round"
        [disabled]="isBudgetEditModeEnabled || !budget?.id || generatingVersion" [nzLoading]="generatingVersion"
        (click)="generateBudgetVersion()">
        {{ generatingVersion ? 'Generando…' : 'Generar presupuesto' }}
      </button>
      @if (budget?.dateCancelled) {
      <!-- Si está cancelado, mostrar botón de recuperar -->
      <button nz-button nzType="default" nzShape="round" [disabled]="isBudgetEditModeEnabled" (click)="recoverBudget()"
        [nzLoading]="recoveringBudget">
        Recuperar Presupuesto
      </button>
      } @else {
      <!-- Si no está cancelado, mostrar botones normales -->
      <button nz-button nzType="default" nzShape="round" [disabled]="isBudgetEditModeEnabled"
        (click)="confirmCancelBudget()" [nzLoading]="cancelingBudget">
        Cancelar Presupuesto
      </button>
      @if (!budget?.dateConfirm) {
      <button nz-button nzType="default" nzShape="round" [disabled]="isBudgetEditModeEnabled"
        (click)="requestApproval()" [nzLoading]="requestingApproval">
        Solicitar Aprobación
      </button>
      }
      <button *ngIf="budget.isActive" nz-button nzType="primary" nzShape="round" [disabled]="isBudgetEditModeEnabled"
        (click)="sendBudget()" [nzLoading]="confirmingBudget">
        <app-st-icon class="text-header-16 cursor-pointer " style="margin-right: 8px; color: #ffffff;" name="mail"
          [bold]="true"></app-st-icon>
        Enviar por correo
      </button>
      @if (!budget?.dateConfirm && budget?.isActive) {
      <!-- Solo mostrar si no está confirmado y está activo -->
      <!--Se cambia el nombre de confirmar a Aprobar para este botón la función permanece igual. -->
      <button nz-button nzType="primary" nzShape="round" [disabled]="isBudgetEditModeEnabled" (click)="confirmBudget()"
        [nzLoading]="confirmingBudget">
        Aprobar
      </button>
      }
      <!-- Adoptar sigue disponible en un pedido de venta aún sin adoptar: sin adopción no hay líneas de venta
           y SourTrack no recibe nada (CEC-641, 02/11). -->
      @if (!budget?.dateConfirm || !budget?.budgetAdopted) {
      <button nz-button nzType="primary" nzShape="round" [disabled]="isBudgetEditModeEnabled" (click)="adoptBudget()"
        [nzLoading]="adoptingBudget">
        Adoptar Presupuesto
      </button>
      }
      }
      } @else {
      <!-- Avatar group -->
      @if (!isLead) {
      <nz-badge class="transparent-badge">
        <div class="flex-center gap-050 followers-group">
          <div class="followers-avatars-container">
            @for (user of opportunityUsers.slice(0, 2); track user.id) {
            <div class="follower-avatar-wrapper">
              <nz-avatar [nzSize]="32" [nzSrc]="user.avatar ? getSafeImageUrl(user.avatar) : undefined"
                [nzText]="!user.avatar ? getUserInitialsFromUser(user) : undefined"
                [style.backgroundColor]="!user.avatar ? '#ffffff' : undefined"
                [style.color]="!user.avatar ? '#000000' : undefined"
                [style.border]="!user.avatar ? '1px solid #d9d9d9' : undefined"
                [style.fontWeight]="!user.avatar ? '600' : undefined" nz-tooltip
                [nzTooltipTitle]="(user.name + ' ' + (user.surName??'')).trim() + (user.isSystemUser && user.role ? ' (' + user.role + ')' : '')">
              </nz-avatar>
            </div>
            }
            @if (opportunityUsers && opportunityUsers.length > 2) {
            <div class="follower-avatar-more" nz-tooltip [nzTooltipTitle]="getRemainingFollowersTooltip()"
              style="cursor: pointer;">
              <span>+{{ opportunityUsers.length - 2 }}</span>
            </div>
            }
          </div>

          <!-- Dropdown para gestionar seguidores -->
          <button nz-button nzType="text" nz-dropdown [nzDropdownMenu]="followersMenu" nzTrigger="click"
            [nzDisabled]="isEditModeEnabled" nzPlacement="bottomLeft" style="margin-left: 8px; border: none; box-shadow: none;" 
            class="followers-dropdown-trigger">
            <app-st-icon [bold]="true" [name]="'more_vert'" style="font-size: 20px; color: #666666;"></app-st-icon>
          </button>

          <nz-dropdown-menu #followersMenu="nzDropdownMenu">
            <div class="followers-dropdown-menu" (click)="$event.stopPropagation()">
              <!-- Opción: Añadir seguidor -->
              @if (canAssignFollowers) {
              <div class="follower-menu-item" (click)="openAddFollowerModal()">
                <app-st-icon [bold]="true" [name]="'add'" style="font-size: 18px; margin-right: 8px;"></app-st-icon>
                <span>Añadir seguidor</span>
              </div>
              }

              <!-- Opción: Seguir/Dejar de seguir -->
              @if (shouldShowUnfollowButton) {
              <div class="follower-menu-item" (click)="unfollowOpportunity()">
                <app-st-icon [bold]="true" [name]="'person_off'"
                  style="font-size: 18px; margin-right: 8px;"></app-st-icon>
                <span>Dejar de seguir</span>
              </div>
              } @else {
              <div class="follower-menu-item" (click)="followOpportunity()">
                <app-st-icon [bold]="true" [name]="'person_add'"
                  style="font-size: 18px; margin-right: 8px;"></app-st-icon>
                <span>Seguir oportunidad</span>
              </div>
              }

              <!-- Separador -->
              <nz-divider style="margin: 8px 0;"></nz-divider>

              <!-- Acordeón: Gestionar seguidores -->
              <nz-collapse nzGhost [(nzActive)]="followersAccordionActive">
                <nz-collapse-panel [nzHeader]="followersHeader" nzActive="1" nzShowArrow="true">
                  <div class="followers-list-accordion">
                    @for (user of opportunityUsers; track user.id) {
                    <div class="follower-item-row">
                      <div class="flex-center gap-050">
                        <nz-avatar [nzSize]="32" [nzSrc]="user.avatar ? getSafeImageUrl(user.avatar) : undefined"
                          [nzText]="!user.avatar ? getUserInitialsFromUser(user) : undefined"
                          [style.backgroundColor]="!user.avatar ? '#f0f0f0' : undefined"
                          [style.color]="!user.avatar ? '#000000' : undefined">
                        </nz-avatar>
                        <div class="follower-info">
                          <div class="follower-name">{{ user.name }} {{ user.surName }}</div>
                          @if (user.isSystemUser && user.role) {
                          <div class="follower-role">{{ user.role }}</div>
                          }
                        </div>
                      </div>
                      @if (!user.isSystemUser) {
                      <button nz-button nzType="text" nzSize="small"
                        (click)="openRemoveFollowerConfirmation(user.id, $event)" nz-tooltip
                        nzTooltipTitle="Eliminar seguidor" class="follower-delete-btn">
                        <app-st-icon [bold]="true" [name]="'delete'" style="font-size: 16px; color: #ff4d4f;"></app-st-icon>
                      </button>
                      }
                    </div>
                    }
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>
          </nz-dropdown-menu>
        </div>
      </nz-badge>

      <nz-divider nzType="vertical" style="height: 32px; margin: 0 8px;"></nz-divider>
      }

      <!-- Botones de acción -->
      @if (!isLost && !isWon) {
      <button nz-button nzType="default" nzShape="round" [disabled]="isEditModeEnabled" (click)="markAsLost()">
        <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" [name]="'cancel'" [bold]="true">
        </app-st-icon>
        Perdido
      </button>
      } @else if (isLost) {
      <button nz-button nzType="default" nzShape="round" [disabled]="isEditModeEnabled" [nzLoading]="recoveringLead"
        (click)="recoverLead()">
        <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" [name]="'restore'" [bold]="true">
        </app-st-icon>
        Restaurar
      </button>
      }

      @if (isLead && !isLost) {
      <!--
              <button
                nz-button
                nzType="default"
                nzShape="round"
                [disabled]="isEditModeEnabled"
                (click)="requestDocuments()">
                <app-st-icon
                  class="text-header-16 cursor-pointer"
                  style="margin-right: 8px"
                  [name]="'description'"
                  [bold]="true">
                </app-st-icon>
                Solicitar documentos necesarios
              </button>
              -->
      }

      @if (!isLead && !isLost && !isWon) {
      <button nz-button nzType="default" nzShape="round" [disabled]="isEditModeEnabled" (click)="markAsWon()">
        <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" [name]="'check_circle'"
          [bold]="true">
        </app-st-icon>
        Ganado
      </button>
      }

      @if (!isLead && !isLost && !isWon) {
      <nz-divider nzType="vertical" style="height: 32px; margin: 0 8px;"></nz-divider>
      }

      @if (isLead && !isLost) {
      <button nz-button nzType="primary" nzShape="round" [disabled]="isEditModeEnabled"
        (click)="convertToOpportunity()">
        Convertir en oportunidad
      </button>
      }

      @if (!isLead && !isLost && canCreateQuote) {
      <button nz-button nzType="default" nzShape="round" [disabled]="isEditModeEnabled" (click)="openBudgetDrawer()">
        <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" [name]="'add'" [bold]="true">
        </app-st-icon>
        Nuevo Presupuesto
      </button>
      }

      @if (!isLead && !isLost && !isWon && currentStageName !== 'Completada') {
      <div nz-dropdown [nzDropdownMenu]="projectDropdownTmpl" nzTrigger="click" nzPlacement="bottomLeft">
        <button nz-button nzType="default" nzShape="round" [disabled]="isEditModeEnabled">
          <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" [name]="'folder'" [bold]="true">
          </app-st-icon>
          Proyecto
          <app-st-icon [bold]="true" [name]="'keyboard_arrow_down'" style="margin-left: 4px;"></app-st-icon>
        </button>
      </div>
      <nz-dropdown-menu #projectDropdownTmpl="nzDropdownMenu">
        <ul nz-menu class="opportunity-dropdown">
          <li nz-menu-item (click)="createProject()">
            <app-st-icon [name]="'add'" [bold]="true" style="margin-right: 8px;"></app-st-icon>
            Nuevo Proyecto
          </li>
          <li nz-menu-item (click)="openLinkProjectModal()">
            <app-st-icon [name]="'link'" [bold]="true" style="margin-right: 8px;"></app-st-icon>
            Asociar Proyecto
          </li>
        </ul>
      </nz-dropdown-menu>
      }
      }
    </div>
  </div>

  <div class="st-drawer-content opportunity-details-content">
    <!-- Contenedor principal con tabs y sidebar -->
    <div class="main-content-wrapper" [class.expanded-panel]="!showActivitiesPanel">
      <!-- Contenido principal con tabs -->
      <div class="main-content">
        <!-- Stepper -->
        <div class="stepper">
          @if (viewMode === 'budget') {
          <!-- Stepper de presupuesto -->
          @for (stage of budgetStagesToDisplay; track stage.value; let isLast = $last) {
          <div class="stepper-item" [ngClass]="getBudgetStageHoverClass(stage.value)"
            [style.color]="isCurrentBudgetStage(stage.value) ? stage.color : null"
            [style.cursor]="nzData.editPermissions ? 'pointer' : 'default'"
            (click)="nzData.editPermissions && changeBudgetStage(stage)">
            <app-st-icon [bold]="true" [name]="stage.icon"></app-st-icon>
            <span>{{ stage.name }}</span>
          </div>
          @if (!isLast) {
          <app-st-icon name="keyboard_arrow_right"></app-st-icon>
          }
          }
          } @else {
          <!-- Stepper de oportunidad/lead -->
          @for (stage of stagesForTeam; track stage.id; let isLast = $last; let index = $index) {
          <div class="stepper-item" [ngClass]="getStageHoverClass(index)"
            [style.color]="isCurrentStage(stage.name) ? getStageColor(index) : null"
            [style.cursor]="nzData.editPermissions ? 'pointer' : 'default'"
            (click)="nzData.editPermissions && changeStage(stage)">
            <app-st-icon [bold]="true" [name]="getStageIcon(index)"></app-st-icon>
            <span>{{ stage.name }}</span>
          </div>
          @if (!isLast) {
          <app-st-icon name="keyboard_arrow_right"></app-st-icon>
          }
          }
          }
        </div>
        @if (viewMode === 'opportunity') {
        <app-sourtrack-sync-status [status]="sourTrackStatus" [detail]="sourTrackDetail"
          [canRetry]="sourTrackCanRetry" [retrying]="syncingSourTrack" (retry)="retrySourTrackSync()">
        </app-sourtrack-sync-status>
        }
        @if (viewMode === 'budget') {
        <!-- Vista de presupuesto -->
        <app-budget-content [budget]="budget" [opportunity]="opportunity" [budgetList]="budgetList"
          [currentBudgetIndex]="currentBudgetIndex" [activeTabIndex]="activeTabIndex"
          [editPermissions]="nzData.editPermissions" [isEditModeEnabled]="isBudgetEditModeEnabled"
          [editModeAction]="budgetEditModeAction" (fieldUpdate)="onBudgetFieldUpdate($event)"
          (budgetChange)="changeBudget($event.isNext, $event.isPrev, $event.budgetId)"
          (currencyConversionValidityChange)="isBudgetCurrencyConversionValid = $event"
          (quotationLinesAvailabilityChange)="hasBudgetQuotationLines = $event" [pdfVersionsRefreshKey]="pdfVersionsRefreshKey"
          style="overflow: auto">
        </app-budget-content>
        } @else if (viewMode === 'lead') {
        <!-- Vista de lead -->
        <app-lead-content [lead]="opportunity" [editPermissions]="nzData.editPermissions"
          [isEditModeEnabled]="isEditModeEnabled" [editModeAction]="editModeAction" [activeTabIndex]="activeTabIndex"
          [documents]="documents" (fieldUpdate)="onFieldUpdate($event)" style="overflow-y: auto">
        </app-lead-content>
        } @else {
        <!-- Vista de oportunidad -->
        <app-opportunity-content [opportunity]="opportunity" [editPermissions]="nzData.editPermissions"
          [isEditModeEnabled]="isEditModeEnabled" [editModeAction]="editModeAction" [activeTabIndex]="activeTabIndex"
          [documents]="documents" [budgets]="budgetList" [activities]="activities" (fieldUpdate)="onFieldUpdate($event)"
          (budgetClick)="openBudgetView($event)" (budgetDeleted)="onBudgetDeleted($event)"
          (navigateToProjectRequest)="onNavigateToProject($event)" style="overflow: auto">
        </app-opportunity-content>
        }
      </div>

      <div class="right-container" [class.mobile-collapsed]="!showActivitiesPanel">
        <app-activities-panel [loadingActivities]="loadingActivities"
          [activitiesGroupedByDate]="activitiesGroupedByDate"
          [opportunity]="viewMode === 'budget' && budget ? budget : opportunity"
          [chatName]="viewMode === 'budget' && budget ? budgetName : getOpportunityName()" [showChat]="true"
          [users]="globalValuesService.users$.value" [loggedUser]="authService.loggedUser$.value"
          [getActivityIconWrapperClassFn]="getActivityIconWrapperClass.bind(this)"
          [getActivityIconFn]="getActivityIcon.bind(this)" [getActivityIconColorFn]="getActivityIconColor.bind(this)"
          [getActivityTimeFn]="getActivityTime.bind(this)" [getActivityDueDateFn]="getActivityDueDate.bind(this)"
          [getUserInitialsFn]="getUserInitials.bind(this)" [getUserFullNameFn]="getUserFullName.bind(this)"
          [getActivityStatusClassFn]="getActivityStatusClass.bind(this)"
          [getActivityStatusLabelFn]="getActivityStatusLabel.bind(this)"
          (openCreateActivity)="openCreateActivityDrawer()" (openRegisterNote)="openRegisterNoteDrawer()"
          (openSendEmail)="openSendEmailDrawer()" (markDone)="markActivityAsCompleted($event)"
          (editActivity)="openEditActivityDrawer($event)"
          (cancelActivity)="cancelActivityAction($event)"></app-activities-panel>
      </div>
    </div>
  </div>
  } @else {
  <nz-skeleton style="padding: 32px" [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
  }
  }
</div>


<!-- Template: Notificación Toast -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
    [showUndo]="toastConfig.showUndo" [notRef]="notRef" [content]="toastConfig.content"
    [msg]="toastConfig.msg"></app-toast>
</ng-template>

<!-- Template: Modal Marcar como Perdido -->
<ng-template #markAsLostModalTmpl>
  <div class="mark-as-lost-modal">
    <div class="flex-center-between">
      <h2 class="text-header-18">{{ 'Marcar perdido' }}</h2>
      <app-st-icon (click)="cancelMarkAsLost()" class="cursor-pointer" name="close" [bold]="true"></app-st-icon>
    </div>

    <form [formGroup]="lostForm">
      <!-- Razón de pérdida -->
      <div>
        <span class="text-label-10">Razón de pérdida</span>
        <nz-select formControlName="reason" nzSize="large" nzPlaceHolder="Seleccione" nzShowSearch
          style="width: 100%; margin-top: 8px;">
          <nz-option *ngFor="let reason of lostReasons" [nzValue]="reason.name" [nzLabel]="reason.name">
          </nz-option>
        </nz-select>
      </div>

      <!-- Nota de cierre -->
      <div style="margin-top: 16px;">
        <span class="text-label-10">Nota de cierre</span>
        <textarea formControlName="lostNote" nzSize="large" nz-input placeholder="¿Qué salió mal?" rows="4"
          class="info-text" style="margin-top: 8px;">
        </textarea>
      </div>

      <!-- Botones -->
      <div class="flex-center-between footer">
        <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="cancelMarkAsLost()">
          Cancelar
        </button>
        <button nz-button nzType="primary" nzShape="round" nzSize="large" [nzLoading]="markingAsLost"
          [disabled]="lostForm.invalid" (click)="confirmMarkAsLost()"
          style="background-color: #000000; border-color: #000000;">
          <app-st-icon [name]="'cancel'" [bold]="true" class="prefix" style="color: white;">
          </app-st-icon>
          <span style="color: white;">Marcar como perdido</span>
        </button>
      </div>
    </form>
  </div>
</ng-template>

<app-confirmation-modal #cancelBudgetConfirmationModal (confirmed)="onCancelBudgetConfirmed()"></app-confirmation-modal>

<app-confirmation-modal #cancelEditModeConfirmationModal
  (confirmed)="onCancelEditModeConfirmed()"></app-confirmation-modal>

<ng-template #unsavedBudgetLeaveModalTmpl>
  <div class="mark-as-lost-modal">
    <div class="flex-center-between">
      <h2 class="text-header-18">Presupuesto sin guardar</h2>
      <app-st-icon (click)="closeUnsavedBudgetLeaveModal()" class="cursor-pointer" name="close" [bold]="true">
      </app-st-icon>
    </div>

    <p class="text-label-14 text-dark">
      Hay un presupuesto nuevo sin guardar. Guarda los cambios o descarta el presupuesto antes de salir.
    </p>

    <div class="flex-center-between footer">
      <button nz-button nzType="text" nzShape="round" nzSize="large" [disabled]="savingBudget"
        (click)="discardUnsavedBudgetAndContinue()">
        Descartar
      </button>
      <button nz-button nzType="primary" nzShape="round" nzSize="large" [nzLoading]="savingBudget"
        (click)="saveUnsavedBudgetAndContinue()">
        Guardar
      </button>
    </div>
  </div>
</ng-template>

<app-confirmation-modal #removeFollowerConfirmationModal
  (confirmed)="onRemoveFollowerConfirmed()"></app-confirmation-modal>

<!-- Template: Modal Ver Todos los Seguidores -->
<ng-template #viewAllFollowersModalTmpl>
  <div class="add-follower-modal">
    <div class="flex-center-between" style="margin-bottom: 24px;">
      <h2 class="text-header-18">Seguidores ({{ opportunityUsers.length }})</h2>
      <app-st-icon (click)="closeViewAllFollowersModal()" class="cursor-pointer" name="close"
        [bold]="true"></app-st-icon>
    </div>

    <!-- Buscador -->
    <div style="margin-bottom: 16px;">
      <div class="search-preffix search follower-search-input">
        <input type="text" nz-input nzSize="large" placeholder="Buscar por nombre o email…..."
          [(ngModel)]="viewAllFollowersSearchText" (ngModelChange)="onViewAllFollowersSearchChange($event)" />
      </div>
    </div>

    <!-- Lista de seguidores -->
    <div style="max-height: 400px; overflow-y: auto;">
      @if (filteredViewAllFollowers.length > 0) {
      @for (user of filteredViewAllFollowers; track user.id) {
      <div class="follower-card">
        <div class="flex-center gap-100" style="width: 100%;">
          <nz-avatar [nzSize]="40" [nzSrc]="user.avatar ? getSafeImageUrl(user.avatar) : undefined"
            [nzText]="!user.avatar ? getUserInitialsFromUser(user) : undefined"
            [style.backgroundColor]="!user.avatar ? '#ffffff' : undefined"
            [style.color]="!user.avatar ? '#000000' : undefined"
            [style.border]="!user.avatar ? '1px solid #d9d9d9' : undefined"
            [style.fontWeight]="!user.avatar ? '600' : undefined">
          </nz-avatar>
          <div class="flex flex-column" style="flex: 1;">
            <span class="text-label-14 text-semibold">{{ user.name || '' }} {{ user.surName || '' }}</span>
            @if (user.isSystemUser && user.role) {
            <span class="system-user-badge" style="margin-top: 2px; align-self: flex-start;">{{ user.role }}</span>
            }
            @if (user.email) {
            <span class="text-label-12" style="color: #666666; margin-top: 2px;">{{ user.email }}</span>
            }
          </div>
          @if (!user.isSystemUser) {
          <button nz-button nzType="text" nzShape="circle" nzSize="small" [disabled]="isEditModeEnabled"
            (click)="openRemoveFollowerConfirmation(user.id, $event)" nz-tooltip [nzTooltipTitle]="'Dejar de seguir'"
            style="color: #ff4d4f;">
            <app-st-icon name="close" [bold]="true" style="font-size: 16px;"></app-st-icon>
          </button>
          }
        </div>
      </div>
      }
      } @else {
      <nz-empty [nzNotFoundContent]="'No se encontraron seguidores'" style="padding: 40px;"></nz-empty>
      }
    </div>
  </div>
</ng-template>

<ng-template #completionModalTmpl>
  <div style="padding: 40px 32px;">
    <div style="margin-bottom: 32px;">
      <label style="font-weight: 500; color: #666; display: block; margin-bottom: 12px; font-size: 14px;">Asignada
        a:</label>
      <div
        style="display: flex; align-items: center; gap: 12px; padding: 16px; background-color: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef;">
        <nz-avatar [nzSize]="40"
          [nzSrc]="completionModalActivity?.user?.partner?.avatar ? getSafeImageUrl(completionModalActivity?.user?.partner?.avatar) : undefined"
          [nzText]="!completionModalActivity?.user?.partner?.avatar ? getUserInitials(completionModalActivity) : undefined"
          style="background-color: #ffffff; color: #000000; font-weight: 600; border: 1px solid #d9d9d9;">
        </nz-avatar>
        <div>
          <div style="font-weight: 600; color: #333; font-size: 16px;">
            {{ completionModalActivity?.user?.partner?.name || 'Sin asignar' }}
          </div>
          <div style="font-size: 14px; color: #666;">
            {{ completionModalActivity?.user?.partner?.surName || '' }}
          </div>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 32px;">
      <label for="completionNote"
        style="font-weight: 500; color: #666; display: block; margin-bottom: 12px; font-size: 14px;">Notas de
        completación:</label>
      <textarea id="completionNote" nz-input [value]="completionNote" (input)="onCompletionNoteChange($event)"
        placeholder="Agregue notas sobre la completación de esta actividad..."
        style="width: 100%; min-height: 140px; resize: vertical; border: 1px solid #d9d9d9; border-radius: 6px; padding: 12px; font-size: 14px; line-height: 1.5;"
        rows="6"></textarea>
    </div>

    <!-- Botones -->
    <div class="flex-center-between" style="margin-top: 32px; padding-top: 24px; border-top: 1px solid #e9ecef;">
      <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="closeCompletionModal()"
        style="background-color: #000000; border-color: #000000;">
        <app-st-icon [name]="'done'" [bold]="true" class="prefix" style="color: white; margin-right: 8px;">
        </app-st-icon>
        Hecho y siguiente actividad
      </button>
      <div style="display: flex; gap: 12px;">
        <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="cancelCompletionModal()">
          Cancelar
        </button>
        <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="confirmCompleteActivity()"
          style="background-color: #000000; border-color: #000000;">
          <app-st-icon [name]="'done'" [bold]="true" class="prefix" style="color: white; margin-right: 8px;">
          </app-st-icon>
          Hecho
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Template: Modal Añadir Seguidor -->
<ng-template #addFollowerModalTmpl>
  <div class="add-follower-modal">
    <div class="flex-center-between" style="margin-bottom: 24px;">
      <h2 class="text-header-18">Añadir seguidor</h2>
      <app-st-icon (click)="closeAddFollowerModal()" class="cursor-pointer" name="close" [bold]="true"></app-st-icon>
    </div>

    <!-- Segmented control -->
    <div style="margin-bottom: 24px;">
      <nz-segmented nzSize="large" [nzOptions]="followerSegmentedOptions" [ngModel]="followerSelectedType"
        (ngModelChange)="onFollowerTypeChange($event)"></nz-segmented>
    </div>

    <!-- Buscador -->
    <div style="margin-bottom: 16px;">
      <div class="search-preffix search follower-search-input">
        <input type="text" nz-input nzSize="large" placeholder="Buscar por nombre o email…..."
          [(ngModel)]="followerSearchText" (ngModelChange)="onFollowerSearchChange($event)" />
      </div>
    </div>

    <!-- Lista de contactos/usuarios -->
    <div style="max-height: 400px; overflow-y: auto;">
      @if (followerSelectedType === 'contact') {
      @if (filteredContacts.length > 0) {
      @for (contact of filteredContacts; track contact.id) {
      <div class="follower-card" [class.selected]="selectedFollowersIds.has(contact.id)">
        <div class="flex-center gap-100" style="width: 100%;">
          <label nz-checkbox [nzChecked]="selectedFollowersIds.has(contact.id)"
            (nzCheckedChange)="toggleFollowerSelection(contact.id, $event)"></label>
          <nz-avatar [nzSize]="40" [nzSrc]="contact.avatar ? getSafeImageUrl(contact.avatar) : undefined"
            [nzText]="!contact.avatar ? getUserInitialsFromContact(contact) : undefined"
            [style.backgroundColor]="!contact.avatar ? '#ffffff' : undefined"
            [style.color]="!contact.avatar ? '#000000' : undefined"
            [style.border]="!contact.avatar ? '1px solid #d9d9d9' : undefined"
            [style.fontWeight]="!contact.avatar ? '600' : undefined">
          </nz-avatar>
          <div class="flex flex-column" style="flex: 1;">
            <span class="text-label-14 text-semibold">{{ contact.name || '' }} {{ contact.surName || '' }}</span>
            @if (contact.email) {
            <span class="text-label-12" style="color: #666666;">{{ contact.email }}</span>
            }
          </div>
        </div>
      </div>
      }
      } @else {
      <nz-empty [nzNotFoundContent]="'No se encontraron contactos'" style="padding: 40px;"></nz-empty>
      }
      } @else {
      @if (filteredUsers.length > 0) {
      @for (user of filteredUsers; track user.id) {
      <div class="follower-card" [class.selected]="selectedFollowersIds.has(user.id)">
        <div class="flex-center gap-100" style="width: 100%;">
          <label nz-checkbox [nzChecked]="selectedFollowersIds.has(user.id)"
            (nzCheckedChange)="toggleFollowerSelection(user.id, $event)"></label>
          <nz-avatar [nzSize]="40" [nzSrc]="user.partner?.avatar ? getSafeImageUrl(user.partner.avatar) : undefined"
            [nzText]="!user.partner?.avatar ? getUserInitialsFromUser(user.partner || user) : undefined"
            [style.backgroundColor]="!user.partner?.avatar ? '#ffffff' : undefined"
            [style.color]="!user.partner?.avatar ? '#000000' : undefined"
            [style.border]="!user.partner?.avatar ? '1px solid #d9d9d9' : undefined"
            [style.fontWeight]="!user.partner?.avatar ? '600' : undefined">
          </nz-avatar>
          <div class="flex flex-column" style="flex: 1;">
            <span class="text-label-14 text-semibold">{{ user.partner?.name || user.name || '' }} {{
              user.partner?.surName || user.surName || '' }}</span>
            @if (user.partner?.email || user.email) {
            <span class="text-label-12" style="color: #666666;">{{ user.partner?.email || user.email }}</span>
            }
          </div>
        </div>
      </div>
      }
      } @else {
      <nz-empty [nzNotFoundContent]="'No se encontraron usuarios'" style="padding: 40px;"></nz-empty>
      }
      }
    </div>

    <!-- Botones -->
    <div class="flex-center-between footer" style="margin-top: 24px; padding-top: 16px; border-top: 1px solid #e9ecef;">
      <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="closeAddFollowerModal()">
        Cancelar
      </button>
      <button nz-button nzType="primary" nzShape="round" nzSize="large" [nzLoading]="addingFollowers"
        [disabled]="selectedFollowersIds.size === 0" (click)="confirmAddFollowers()"
        style="background-color: #000000; border-color: #000000;">
        <span style="color: white;">Añadir ({{ selectedFollowersIds.size }})</span>
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal Asociar proyecto existente -->
<ng-template #linkProjectModalTmpl>
  <div class="add-follower-modal">
    <div class="flex-center-between" style="margin-bottom: 24px;">
      <h2 class="text-header-18">Asociar proyecto</h2>
      <app-st-icon (click)="closeLinkProjectModal()" class="cursor-pointer" name="close" [bold]="true"></app-st-icon>
    </div>
    <p class="text-label-14" style="color: #666; margin-bottom: 16px;">
      Selecciona un proyecto existente para asociarlo a esta oportunidad.
    </p>
    @if (loadingLinkProjects) {
    <div class="flex-center" style="padding: 40px;">
      <nz-spin nzSimple></nz-spin>
    </div>
    } @else {
    <div style="max-height: 320px; overflow-y: auto;">
      @if (availableProjectsForLink.length > 0) {
      @for (proj of availableProjectsForLink; track proj.id) {
      <div class="follower-card" [class.selected]="linkProjectSelectedId === proj.id"
        (click)="linkProjectSelectedId = proj.id">
        <div class="flex-center gap-100" style="width: 100%;">
          <app-st-icon [name]="'folder'" [bold]="true" style="color: #0072F5; font-size: 20px;"></app-st-icon>
          <div class="flex flex-column" style="flex: 1;">
            <span class="text-label-14 text-semibold">{{ proj.name || proj.reference || 'Proyecto #' + proj.id }}</span>
            @if (proj.reference && proj.name) {
            <span class="text-label-12" style="color: #666666;">{{ proj.reference }}</span>
            }
          </div>
          @if (linkProjectSelectedId === proj.id) {
          <app-st-icon name="check_circle" style="color: #52c41a; font-size: 20px;"></app-st-icon>
          }
        </div>
      </div>
      }
      } @else {
      <nz-empty [nzNotFoundContent]="'No hay proyectos disponibles para asociar'" style="padding: 40px;"></nz-empty>
      }
    </div>
    }
    <div class="flex-center-between footer" style="margin-top: 24px; padding-top: 16px; border-top: 1px solid #e9ecef;">
      <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="closeLinkProjectModal()">
        Cancelar
      </button>
      <button nz-button nzType="primary" nzShape="round" nzSize="large" [nzLoading]="linkingProjectId != null"
        [disabled]="!linkProjectSelectedId" (click)="confirmLinkProject()"
        style="background-color: #000000; border-color: #000000;">
        Asociar
      </button>
    </div>
  </div>
</ng-template>

<!-- Template: Header del acordeón de seguidores -->
<ng-template #followersHeader>
  <div class="flex-center-between" style="width: 100%;">
    <span style="font-weight: 500;">Gestionar seguidores ({{ opportunityUsers.length }})</span>
  </div>
</ng-template>
